<template>
  <nav v-if="totalPages > 1" :class="$style.nav" :aria-label="t('aria')">
    <button
      type="button"
      :class="$style.btn"
      :disabled="page <= 1 || disabled"
      @click="emit('go', page - 1)"
    >
      <ui-icon name="chevron-left" :class="$style.icon" />
      <span :class="$style.btnLabel">{{ t('prev') }}</span>
    </button>

    <span :class="$style.info" aria-live="polite">
      {{ t('info', { current: page, total: totalPages }) }}
    </span>

    <button
      type="button"
      :class="$style.btn"
      :disabled="page >= totalPages || disabled"
      @click="emit('go', page + 1)"
    >
      <span :class="$style.btnLabel">{{ t('next') }}</span>
      <ui-icon name="chevron-right" :class="$style.icon" />
    </button>
  </nav>
</template>

<i18n lang="yaml">
ru:
  aria: Пагинация лидерборда
  prev: Назад
  next: Вперёд
  info: 'Страница {current} из {total}'
</i18n>

<script lang="ts" setup>
import UiIcon from '@/ui-core/components/icon/index.vue'

defineOptions({ name: 'PickemLeaderboardPagination' })

defineProps<{
  page: number
  totalPages: number
  disabled?: boolean
}>()

const emit = defineEmits<{
  go: [page: number]
}>()

const { t } = useI18n()
</script>

<style lang="scss" module>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
}

.btn {
  appearance: none;
  background: transparent;
  border: 1px solid color-get(--root-rgb-bg-border);
  border-radius: 0.6em;
  padding: 0.6em 1em;
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  cursor: pointer;
  color: color-get(--root-rgb-text-1);
  @include typo-get(body-s);

  @include hover-focus {
    border-color: color-get(--root-rgb-accent-2);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
    pointer-events: none;
  }
}

.btnLabel {
  @include down(sm) {
    display: none;
  }
}

.icon {
  width: 1.4em;
  height: 1.4em;
}

.info {
  @include typo-get(body-s);
  color: color-get(--root-rgb-text-2);
}
</style>
